<template>
	<div class="menus-wrap" v-if="status" :key="componentKey">
		<head-info></head-info>
		<div id="print-wrap" class="relative-wrap">
			<div class="photo"><img v-if="info.photo" :src="info.photo + '?_=' + new Date().getTime()" alt="" /></div>
			<el-descriptions :title="`${examination_name}报名信息表`" border>
				<el-descriptions-item :labelStyle="{ width: '100px' }" :contentStyle="{ width: '200px' }" label="姓名">{{ info.name }}</el-descriptions-item>
				<el-descriptions-item :labelStyle="{ width: '100px' }" label="性别">{{ info.gender && info.gender === 1 ? '男' : info.gender && info.gender === 2 ? '女' : '-' }}</el-descriptions-item>
				<el-descriptions-item
					:labelStyle="{ width: '0', backgroundColor: '#fff', border: '1px solid transparent', borderTopColor: '#000000' }"
					:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#000000', borderTopColor: '#000000' }"
				></el-descriptions-item>
				<el-descriptions-item label="身份证号">{{ info.card_id || '-' }}</el-descriptions-item>
				<el-descriptions-item label="出生年月">{{ info.date_birth || '-' }}</el-descriptions-item>
				<el-descriptions-item
					:labelStyle="{ backgroundColor: '#fff', border: '1px solid transparent' }"
					:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#000000' }"
				></el-descriptions-item>
				<template v-if="info.details.length >= 4">
					<template v-for="(item, index) in info.details.slice(0, 2)">
						<el-descriptions-item :label="item.name">
							<template v-if="+item.type === 5">
								<div class="grid-wrap">
									<el-image v-for="(val, index) in item.value" :key="index" :src="val.url" :preview-src-list="item.value.map(v => v.url)">
										<div slot="error" style="text-align: center;"><i style="font-size: 30px;" class="el-icon-picture-outline"></i></div>
									</el-image>
								</div>
							</template>
							<template v-else-if="+item.type === 4">
								{{ item.value?item.value.join('、'):'' }}
							</template>
							<template v-else>
								{{ item.value }}
							</template>
						</el-descriptions-item>
					</template>
					<el-descriptions-item
					:labelStyle="{ backgroundColor: '#fff', border: '1px solid transparent' }"
					:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#000000' }"
				></el-descriptions-item>
					<template v-for="(item, index) in info.details.slice(2, 4)">
						<el-descriptions-item :label="item.name">
							<template v-if="+item.type === 5">
								<div class="grid-wrap">
									<el-image v-for="(val, index) in item.value" :key="index" :src="val.url" :preview-src-list="item.value.map(v => v.url)">
										<div slot="error" style="text-align: center;"><i style="font-size: 30px;" class="el-icon-picture-outline"></i></div>
									</el-image>
								</div>
							</template>
							<template v-else-if="+item.type === 4">
								{{ item.value?item.value.join('、'):'' }}
							</template>
							<template v-else>
								{{ item.value }}
							</template>
						</el-descriptions-item>
					</template>
					<el-descriptions-item
					:labelStyle="{ backgroundColor: '#fff', border: '1px solid transparent', borderBottomColor: '#000000' }"
					:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#000000', borderBottomColor: '#000000' }"
				></el-descriptions-item>
					<template v-for="(item, index) in info.details.slice(4)">
						<el-descriptions-item :span="index % 2 === 0 ? 1 : 2" :label="item.name">
							<template v-if="+item.type === 5">
								<div class="grid-wrap">
									<el-image v-for="(val, index) in item.value" :key="index" :src="val.url" :preview-src-list="item.value.map(v => v.url)">
										<div slot="error" style="text-align: center;"><i style="font-size: 30px;" class="el-icon-picture-outline"></i></div>
									</el-image>
								</div>
							</template>
							<template v-else-if="+item.type === 4">
								{{ item.value?item.value.join('、'):'' }}
							</template>
							<template v-else>
								{{ item.value }}
							</template>
						</el-descriptions-item>
					</template>
					<template v-if="info.details.length % 2 === 0">
						<template v-if="showPay">
							<el-descriptions-item label="缴费状态">{{ is_pay }}</el-descriptions-item>
							<el-descriptions-item label="审核状态" :span="2">{{ verify }}</el-descriptions-item>
							<el-descriptions-item label="报名序号">{{ serial_id }}</el-descriptions-item>
							<el-descriptions-item label="报考单位" :span="2">{{ info.department || '-' }}</el-descriptions-item>
							<el-descriptions-item label="报考岗位">{{ info.position || '-' }}</el-descriptions-item>
							<el-descriptions-item label="报考科目" :span="2">
								<template v-if="info.subject && info.subject.length">
									<p v-for="item in info.subject">{{ item.subject_name }}</p>
								</template>
								<template v-else>
									-
								</template>
							</el-descriptions-item>
							<el-descriptions-item label="考试费用(元)">
								<template v-if="info.subject && info.subject.length">
									<p v-for="item in info.subject">{{ item.subject_name }}：{{ item.amount }}元</p>
								</template>
								<template v-else>
									-
								</template>
							</el-descriptions-item>
						</template>
						<template v-else>
							<el-descriptions-item label="审核状态">{{ verify }}</el-descriptions-item>
							<el-descriptions-item label="报名序号" :span="2">{{ serial_id }}</el-descriptions-item>
							<el-descriptions-item label="报考单位">{{ info.department || '-' }}</el-descriptions-item>
							<el-descriptions-item label="报考岗位" :span="2">{{ info.position || '-' }}</el-descriptions-item>
							<el-descriptions-item label="报考科目">
								<template v-if="info.subject && info.subject.length">
									<p v-for="item in info.subject">{{ item.subject_name }}</p>
								</template>
								<template v-else>
									-
								</template>
							</el-descriptions-item>
							<el-descriptions-item label="考试费用(元)" :span="2">
								<template v-if="info.subject && info.subject.length">
									<p v-for="item in info.subject">{{ item.subject_name }}：{{ item.amount }}元</p>
								</template>
								<template v-else>
									-
								</template>
							</el-descriptions-item>
						</template>
					</template>
					<template v-else>
						<template v-if="showPay">
							<el-descriptions-item label="缴费状态" :span="2">{{ is_pay }}</el-descriptions-item>
							<el-descriptions-item label="审核状态">{{ verify }}</el-descriptions-item>
							<el-descriptions-item label="报名序号" :span="2">{{ serial_id }}</el-descriptions-item>
							<el-descriptions-item label="报考单位">{{ info.department || '-' }}</el-descriptions-item>
							<el-descriptions-item label="报考岗位" :span="2">{{ info.position || '-' }}</el-descriptions-item>
							<el-descriptions-item label="报考科目">
								<template v-if="info.subject && info.subject.length">
									<p v-for="item in info.subject">{{ item.subject_name }}</p>
								</template>
								<template v-else>
									-
								</template>
							</el-descriptions-item>
							<el-descriptions-item label="考试费用(元)" :span="2">
								<template v-if="info.subject && info.subject.length">
									<p v-for="item in info.subject">{{ item.subject_name }}：{{ item.amount }}元</p>
								</template>
								<template v-else>
									-
								</template>
							</el-descriptions-item>
						</template>
						<template v-else>
							<el-descriptions-item label="审核状态" :span="2">{{ verify }}</el-descriptions-item>
							<el-descriptions-item label="报名序号">{{ serial_id }}</el-descriptions-item>
							<el-descriptions-item label="报考单位" :span="2">{{ info.department || '-' }}</el-descriptions-item>
							<el-descriptions-item label="报考岗位">{{ info.position || '-' }}</el-descriptions-item>
							<el-descriptions-item label="报考科目" :span="2">
								<template v-if="info.subject && info.subject.length">
									<p v-for="item in info.subject">{{ item.subject_name }}</p>
								</template>
								<template v-else>
									-
								</template>
							</el-descriptions-item>
							<el-descriptions-item label="考试费用(元)">
								<template v-if="info.subject && info.subject.length">
									<p v-for="item in info.subject">{{ item.subject_name }}：{{ item.amount }}元</p>
								</template>
								<template v-else>
									-
								</template>
							</el-descriptions-item>
						</template>
					</template>
				</template>
			</el-descriptions>
		</div>
		<div class="footer-btns" v-if="info.is_pay !== 1 && info.verify === 3">
		<el-button v-if="mobile === 0" type="primary" v-print="'print-wrap'">点击打印</el-button>
		<el-button v-else type="primary" @click="downloadClick">点击下载</el-button>
		</div>
	</div>
</template>

<script>
import HeadInfo from '@/components/HeadInfo';
import {mapGetters, mapState} from 'vuex';
import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';
import { reqGetUserInfo, reqLoginName } from '@/api';
export default {
	components: {
		HeadInfo
	},
	data() {
		return {
			componentKey: 0,
			status: false,
			info: {
				details: [],
				payment: {
					alipay_app_id: null,
					wechat_app_id: null,
					yeepay_app_id: null
				}
			}
		};
	},
	computed: {
		...mapState({
			payment: state => state.system.payment,
			unitName: state => state.system.unitName,
			mobile: state => state.system.mobile,
			examination_name: state => state.system.examInfo.examination_name,
		}),
		...mapGetters('user',['GET_USER_INFO']),
		verify() {
			try {
				return this.info.verify === 1 ? '未审核' : this.info.verify === 2 ? '未通过' : this.info.verify === 3 ? '已通过' : '-';
			} catch (e) {
				//TODO handle the exception
				return '-';
			}
		},
		/*verify() {
			try {
				return this.info.retrial === 3 ? '已通过' : this.info.verify === 2 ? `未通过（原因：${this.info.verify_txt}）` : this.info.retrial === 2 ? `未通过（原因：${this.info.verify_retrial_txt}）` : this.info.verify === 4 ? `等待审核（原因：${this.info.verify_txt}）` : '未审核';
			} catch (e) {
				//TODO handle the exception
				return '-';
			}
		},*/
		id() {
			return this.$store.state.user.examinee.id;
		},
		serial_id() {
			return this.$store.state.user.examinee.serial_id;
		},
		is_pay() {
			try {
				return this.info.is_pay === 1 ? '未缴费' : this.info.is_pay === 2 ? '已缴费' : this.info.is_pay === 3 ? '已减免' : this.info.is_pay === 4 ? '已确认' : this.info.is_pay === 5 ? '申请退费' : this.info.is_pay === 0 ? '已退费' : '-';
			} catch (e) {
				//TODO handle the exception
				return '-';
			}
		},
		// 显示缴费状态
		showPay() {
			return this.payment && (this.payment.alipay_app_id || this.payment.wechat_app_id || this.payment.yeepay_app_id);
		}
	},
	activated() {
		this.getInfo();
	},
	methods: {
		async getInfo() {
			if (this.GET_USER_INFO.id) {
		       this.status = true;
		       this.info = this.GET_USER_INFO;
		     } else {
		       await reqGetUserInfo().then(res => {
			 this.status = true;
			 this.info = {
			   ...res.data,
			   details: res.data.details ? res.data.details : []
			 };
		       })
		     }
		},
		
		 downloadClick() {
		      var title = `${this.info.name}-${this.unitName}考生详细信息`;
		      html2Canvas(document.querySelector('#print-wrap'), {
			allowTaint: true,
			    scale: 2,
			    dpi: 600,//导出pdf清晰度
			    useCORS: true
		      }).then(function (canvas) {
			var pdf = new JsPDF('p', 'mm', 'a4');    //A4纸，纵向
			var ctx = canvas.getContext('2d'),
			  a4w = 190, a4h = 277,    //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
			  imgHeight = Math.floor(a4h * canvas.width / a4w),    //按A4显示比例换算一页图像的像素高度
			  renderedHeight = 0;
		 
			while (renderedHeight < canvas.height) {
			  var page = document.createElement("canvas");
			  page.width = canvas.width;
			  page.height = Math.min(imgHeight, canvas.height - renderedHeight);//可能内容不足一页
		 
			  //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
			  page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0);
			  pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 10, 10, a4w, Math.min(a4h, a4w * page.height / page.width));    //添加图像到页面，保留10mm边距
			  renderedHeight += imgHeight;
			  if (renderedHeight < canvas.height)
			    pdf.addPage();//如果后面还有内容，添加一个空页
			  // delete page;
			}
			pdf.save(title + '.pdf')
		      })
		    },
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/color.scss';

.relative-wrap {
	position: relative;
	margin: auto;
	max-width: 780px;

	.photo {
		width: 110px;
		height: 148px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		top: 112px;
		right: 82px;
		transform: translate(50%, -50%);

		img {
			max-width: 100%;
			max-height: 100%;
			object-fit: contain;
		}
	}
	pre {
		font-family: "Microsoft YaHei";
		white-space: pre-wrap;
		word-wrap: break-word;
		tab-size: 7;
		-moz-tab-size: 7;
		-o-tab-size: 7;

	}

	::v-deep.el-descriptions {

		.el-descriptions__header {
			justify-content: center;
			font-weight: bold;
			color: #000000;

			.el-descriptions__title {
				font-weight: bold;
			}
		}

		.el-descriptions__body {
			.el-descriptions__table .el-descriptions-item__cell {
				line-height: 20px;
				border: 1px solid;
				borderColor: #000000;
				color: #000000;
			}
		}
	}
}
</style>
